<!-- <nav class="navbar navbar-expand-lg navbar-light" style="background-color: #0D4F8B;height: 70px;padding: 15px;">
    <h6 fxLayout="row" fxLayoutAlign="start center" class="logo" ngClass.xs="mobile">
        <img src="assets/logo.png" alt="logo" class="logoImg"> &nbsp;&nbsp;
        <img src="assets/SLA-Logo-1.jpg" alt="logo" class="logoImg">
        <span class="mx-2" style="font-size: 20px;"><strong>AICTE - Student Learning Assessment</strong></span>
    </h6>
    <button class="navbar-toggler" type="button" style="color: white !important;" data-toggle="collapse"
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <mat-icon>menu</mat-icon>
    </button>
    <div class="collapse navbar-collapse row" id="navbarSupportedContent">
        <div class="col-6">

        </div>
        <div class="col-6">
            <ul class="navbar-nav mr-auto floatRight">
                <li class="nav-item">
                    <div *ngIf="role=='Moderator'">
                        <a href="{{baseUrl}}" target="_blank" class="nav-link"
                            style="color: white; font-size: 16px;"><strong>Reviewer Guidelines</strong></a>
                    </div>
                </li>
                <li class="nav-item">
                    <button class="nav-item m-2 grievanceButton" *ngIf="loggedIn" mat-raised-button
                    (click)="grievance()"><mat-icon style="color:#0d4f8b">contact_support</mat-icon>Grievances</button>
                </li>
                <li class="nav-item">
                    <button mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger"
                        style="margin-right: 15px;">
                        <mat-icon style="font-size: 35px;padding-top: 7px;color: #fff;">account_circle</mat-icon>
                    </button>

                    <mat-menu #userMenu="matMenu" [overlapTrigger]="false"
                        class="toolbar-dropdown-menu user-menu menuProfileContainer" style="width: 300px;">
                        <mat-card fxLayout="row" fxLayoutAlign="space-around center" class="user-info userInfo">
                            <img src="assets/img/avatars/profile.png" alt="user-image"
                                style="width: 75px;height:75px;align-self: center;">
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <p style="color: black;">Name: {{user?.firstName + ' ' + user?.lastName}}</p>
                                <p style="color: black;">Email: {{user?.email}}</p>
                                <p style="color: black;">Last Login: {{user?.lastLogin}}</p>
                            </div>
                        </mat-card>
                    </mat-menu>



                </li>
                <li class="nav-item">
                    <button mat-raised-button class="btn LogOutBtn" color="accent" (click)="logout()">Logout</button>
                </li>
            </ul>
        </div>


    </div>
</nav> -->


<nav class="navbar navbar-expand-sm navbar-light row" *ngIf="loggedIn" style="background-color: #0D4F8B;">
    <div class="col-7 p-0">
        <div class="LogoContainer">
            <img src="assets/images/AICTELogo.png" alt="Logo" class="logoImg">
            <img src="assets/images/SLALogo.png" alt="Logo" class="logoImg">
            <img src="assets/images/Parakhlogo.png" alt="Logo" class="logoImg" style="height: 47px;">
        </div>
    </div>

    <div class="col-5">
        <div class="navbar-nav">
            <div *ngIf="role=='Moderator'">
                <a href="{{baseUrl}}" target="_blank" class="nav-link" style="color: white; font-size: 16px; padding-top: 12px;"><strong>Reviewer Guidelines</strong></a>
            </div>
            <button class="nav-item m-2 grievanceButton" *ngIf="loggedIn" mat-raised-button (click)="grievance()"><mat-icon style="color:#0d4f8b">contact_support</mat-icon>Grievances</button>
            <button mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger" style="margin-right: 15px;">
                        <mat-icon style="font-size: 35px;padding-top: 7px;color: #fff;">account_circle</mat-icon>
                    </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu user-menu menuProfileContainer" style="width: 300px;">
                <mat-card fxLayout="row" fxLayoutAlign="space-around center" class="user-info userInfo">
                    <img src="assets/img/avatars/profile.png" alt="user-image" style="width: 75px;height:75px;align-self: center;">
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <p style="color: black;">Name: {{user?.firstName + ' ' + user?.lastName}}</p>
                        <p style="color: black;">Email: {{user?.email}}</p>
                        <p style="color: black;">Last Login: {{user?.lastLogin}}</p>
                        <a routerLink="/reset-password">Reset Password</a>
                    </div>
                </mat-card>
            </mat-menu>
            <button class="nav-item m-2 logoutButton" *ngIf="loggedIn" mat-raised-button (click)="logout()">Logout</button>
        </div>
    </div>
</nav>